import React, { useEffect, useState, createContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Register from "./pages/register/register";
import Welcome from "./pages/welcome/welcome";
import Scan from "./pages/scan/scan";
import MemberRight from "./pages/memberRight/memberRight";
import HandAdding from "./pages/handAdding/handAdding";
import Main from "./pages/main/main";
import MemberData from "./pages/memberData/memberData";
import MemberRecord from "./pages/memberRecord/memberRecord";
import Loading from "./pages/loading/loading";
import { initLiffApp } from "./utils/config";
import Email from "./pages/email/email";
import Missing from "./pages/missing/missing";
import ReseravtionMenu from "./pages/reservationMenu/reservationMenu";
import ReservationGuideline from "./pages/reservationGuideline/reservationGuideline";
import Reservation from "./pages/reservation/reservation";
import ReservSuccess from "./pages/reservSuccess/reservSuccess";
import Error from "./pages/error/error";
import ReservList from "./pages/reservList/reservList";
import ReservatoinChange from "./pages/reservChange/reservChange";
import CodePlace from "./pages/codePlace/codePlace";
import QrcodePlace from "./pages/qrcodePlace/qrcodePlace";
import EmailRes from "./pages/emailRes/emailRes";
export const AuthContext = createContext(null);

const App = () => {
  const [lineProfile, setLineProfile] = useState(null);
  const [isEmailres, setEmailres] = useState(false);
  const [isMemberRight, setMemberRight] = useState(false);
  useEffect(() => {
    const initializeLiff = async () => {
      const profile = await initLiffApp();
      setLineProfile(profile);
    };
    if (window.location.pathname === "/emailres") setEmailres(true);
    else if(window.location.pathname === "/memberright") setMemberRight(true);
    else {
      initializeLiff();
      // setLineProfile({
      //   userId: "testerkkk",
      //   displayName:"tester",
      // })

    }
  }, []);

  if (isEmailres) {
    const urlParams = new URLSearchParams(window.location.search);
    const result = urlParams.get("result");
    return <EmailRes result={result} />;
  }
  else if(isMemberRight){
    return <MemberRight outside={true}/> ;
  } 
  else {
    if (!lineProfile) {
      return <Loading />;
    }
    return (
      <Router>
        <AuthContext.Provider value={lineProfile}>
          <Routes>
            <Route path="/error" element={<Error />} />
            <Route path="/" element={<Main />} />
            <Route path="/register" element={<Register />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/memberright" element={<MemberRight />} />
            <Route path="/handadding" element={<HandAdding />} />
            <Route path="/main" element={<Main />} />
            <Route path="/memberdata" element={<MemberData />} />
            <Route path="/memberrecord" element={<MemberRecord />} />
            <Route path="/email" element={<Email />} />
            <Route path="/missing" element={<Missing />} />
            <Route path="/reservationmenu" element={<ReseravtionMenu />} />
            <Route
              path="/reservationguideline"
              element={<ReservationGuideline />}
            />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/reservsuccess" element={<ReservSuccess />} />
            <Route path="/reservlist" element={<ReservList />} />
            <Route path="/reservchange" element={<ReservatoinChange />} />
            <Route path="/codeplace" element={<CodePlace />} />
            <Route path="/qrcodeplace" element={<QrcodePlace />} />
          </Routes>
        </AuthContext.Provider>
      </Router>
    );
  }
};

export default App;
